// Base URL for the api/ serverless functions. Blank means "same origin", which
// is correct in production and under `vercel dev`. Set REACT_APP_API_BASE only
// to point local development at another deployment or a local mock.
//
// SECURITY — read this before touching process.env anywhere in src/:
// If code references a REACT_APP_ variable that is NOT defined at build time,
// webpack cannot substitute it, so it inlines the ENTIRE process.env object into
// the public bundle and looks the key up at runtime. Every REACT_APP_ variable
// set in Vercel ships with it — secrets included. That is how the database token
// and the EmailJS private key ended up public.
//
// So: read this variable here and nowhere else, and keep it defined in
// .env.production (an empty value is fine) so webpack replaces it statically.
// scripts/check-bundle.js fails the build if the env object leaks again.
export const API_BASE = (process.env.REACT_APP_API_BASE || '').replace(/\/$/, '');
